import { ChargeSettlementReducerDispatch, ChargeSettlementReduxState, ChargeSettlementReduxTypes, CreateChargeSettlementReduxState } from "./types"

const CHARGE_SETTLED_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
}

const CREATE_CHARGE_SETTLEMENT_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const ChargeSettlementListReducer = (state: ChargeSettlementReduxState = CHARGE_SETTLED_INIT_STATE, action: ChargeSettlementReducerDispatch) => {
    switch (action.type) {
        case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_REQUEST: {
            return {
                ...state,
                loading: true
            }

        }
        case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }

        case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENTS_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.RESET: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}

const ChargeSettlementDetailReducer = (state: ChargeSettlementReduxState = CHARGE_SETTLED_INIT_STATE, action: ChargeSettlementReducerDispatch) => {
    switch (action.type) {
        case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_REQUEST: {
            return {
                ...state,
                data: action.payload.data,
                loading: true
            }
        }
        case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_BY_EXTERNAL_ID_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.RESET: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}

const ChargeSettlementAuditActionsReducer = (state: ChargeSettlementReduxState = CHARGE_SETTLED_INIT_STATE, action: ChargeSettlementReducerDispatch)=>{
  switch (action.type) {
    case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case ChargeSettlementReduxTypes.FETCH_CHARGE_SETTLEMENT_AUDIT_ACTIONS_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case ChargeSettlementReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const CreateChargeSettlementReducer = (state: CreateChargeSettlementReduxState = CREATE_CHARGE_SETTLEMENT_INIT_STATE, action: ChargeSettlementReducerDispatch) => {
    switch (action.type) {
        case ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.CREATE_CHARGE_SETTLEMENT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.RESET: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state }
    }
}

const ApproveChargeSettlementReducer = (state: CreateChargeSettlementReduxState = CREATE_CHARGE_SETTLEMENT_INIT_STATE, action: ChargeSettlementReducerDispatch) => {
    switch (action.type) {
        case ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_APPROVE_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.RESET: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state }
    }
}

const RejectChargeSettlementReducer = (state: CreateChargeSettlementReduxState = CREATE_CHARGE_SETTLEMENT_INIT_STATE, action: ChargeSettlementReducerDispatch) => {
    switch (action.type) {
        case ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.CHARGE_SETTLEMENT_REJECT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ChargeSettlementReduxTypes.RESET: {
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state }
    }
}

export { ChargeSettlementListReducer, ChargeSettlementDetailReducer, ChargeSettlementAuditActionsReducer, CreateChargeSettlementReducer, ApproveChargeSettlementReducer, RejectChargeSettlementReducer };